import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import { strings } from "../Utilities/strings";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import Logout from "./Logout";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";
import searchIcon from "../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import {
  addMainStoreMaster,
  getMainStoreMaster,
} from "../Utilities/URLCONSTANTS";
import Loader from "../Utilities/Loader";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import * as XLSX from "xlsx";
import { customstyles, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import Add_Icon from "../images/Add_Icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import Pagination from "../Utilities/Pagination";

// Main Store Master

const MainStoreMaster = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  //const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [storeLocation, setStoreLocation] = useState("");
  // const [userId, setUserId] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactMobileNumber, setContactMobileNumber] = useState("");
  const [status, setStatus] = useState("");
  const [Id, setId] = useState(0);
  const [recordExists, setRecordExists] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [buttonText, setButtonText] = useState(strings.recordSubmitted);
  const [showPopup, setShowPopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [errorName, setErrorName] = useState("");
  const [errorStoreLocation, setErrorStoreLocation] = useState("");
  // const [errorUserId, setErrorUserId] = useState('');
  const [errorContactPerson, setErrorContactPerson] = useState("");
  const [errorMobileNumber, setErrorMobileNumber] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [errorRemarks, setErrorRemarks] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [modalData, setModalData] = useState({
    Id: "",
    name: "",
    storeLocation: "",
    userId: "",
    contactPerson: "",
    contactMobileNumber: "",
    remarks: "",
    status: "",
  });
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  // const totalItems = filteredData.length;
  // In your handleFilter function, update filteredData based on searchTerm
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.storeLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.contactMobileNumber
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.status.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  // const totalItems = data.length;

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    // for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Name",
        "store Location",
        "contact Person",
        "contact Mobile Number",
        "Status",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item) => [
        item.id,
        item.name,
        item.storeLocation,
        item.contactPerson,
        item.contactMobileNumber,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Save the file
    XLSX.writeFile(wb, "MainStoreMaster.xlsx");
  };

  // ...more items

  const handleNameChange = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorName("");
    }
    const result = input.replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    // setModalData.name(result)
    setName(result);
  };

  const handleContactPersonChange = (e) => {
    const contactPerson = e.target.value;

    if (contactPerson.length > 0) {
      setErrorContactPerson("");
    }
    const result = contactPerson.replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setContactPerson(result);
  };

  // const handleStoreLocationChange = (e) => {
  //   if (storeLocation.length > 0) {
  //     setErrorStoreLocation("");
  //   }
  //   setStoreLocation(e.target.value);
  // };

  const handleStoreLocationChange = (e) => {
    const input = e.target.value;
    if (input.length > 0) {
      setErrorStoreLocation("");
    }
    const formattedInput = input.replace(
      /\b[a-z]/g,
      (char) => char.toUpperCase()
    );
    setStoreLocation(formattedInput);
  };

  const handleMobileNbr = (e) => {
    const input = e.target.value;
    let result = input.replace(/[^0-9]/g, ""); // Remove non-digit characters
    if (contactMobileNumber.length > 0) {
      setErrorMobileNumber("");
    }
    if (result.length > 10) {
      result = result.substr(0, 10);
    }
    if (input.length < 10) {
      setErrorMobileNumber("Please enter a valid 10-digit mobile number.");
      // return;
    }
    if (/^[6-9]/.test(result)) {
      setContactMobileNumber(result);

    } else {
      setContactMobileNumber("");
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
    if (e.target.value) {
      setErrorStatus("");
    }
  };

  const handleRemarks = (e) => {
    if (remarks.length > 0) {
      setErrorRemarks("");
    }
    setRemarks(e.target.value);
  };

  // const handleSubmit = () => {
  //   if (name === "") {
  //     setErrorName("Please Enter a Name");
  //   }

  //   if (storeLocation === "") {
  //     setErrorStoreLocation("Please Enter StoreLocation");
  //   }

  //   if (contactPerson === "") {
  //     setErrorContactPerson("Please Enter Contact Person");
  //   }
  //   if (contactMobileNumber === "") {
  //     setErrorMobileNumber("Please Enter   Mobile Number");
  //   }

  //   if (status === "") {
  //     setErrorStatus("Please Enter status");
  //   }

  //   if (recordExists) {
  //     setRecordExists("Record already exists.");
  //     return; // Stop further processing if the record exists
  //   }

  //   if (
  //     name !== "" &&
  //     storeLocation !== "" &&
  //     contactPerson !== "" &&
  //     contactMobileNumber !== "" &&
  //     status !== ""
  //   ) {
  //     if (Id == 0) {
  //       setIsSubmitted(true);
  //       handlePostData();
  //       setErrorName("");
  //       setErrorRemarks("");
  //       setErrorStoreLocation("");
  //       setErrorContactPerson("");
  //       setErrorMobileNumber("");
  //       setErrorStatus("");
  //     } else {
  //       setIsSubmitted(false);
  //       handlePostData();
  //       setIsUpdated(true);
  //     }
  //   }
  // };

  const handleSubmit = () => {
    let isValid = true;

    if (name === "") {
      setErrorName("Please Enter a Name");
      isValid = false;
    }

    if (storeLocation === "") {
      setErrorStoreLocation("Please Enter Store Location");
      isValid = false;
    }

    if (contactPerson === "") {
      setErrorContactPerson("Please Enter Contact Person");
      isValid = false;
    }

    // Mobile number validation
    if (contactMobileNumber === "") {
      setErrorMobileNumber("Please Enter Mobile Number");
      isValid = false;
    } else if (contactMobileNumber.length < 10) {
      setErrorMobileNumber("Please enter a valid 10-digit mobile number.");
      isValid = false;
    } else {
      setErrorMobileNumber("");
    }

    if (status === "") {
      setErrorStatus("Please Enter Status");
      isValid = false;
    }

    if (recordExists) {
      setRecordExists("Record already exists.");
      return;
    }

    // Stop submission if any validation fails
    if (!isValid) {
      return;
    }

    if (Id == 0) {
      setIsSubmitted(true);
      handlePostData();

      setErrorName("");
      setErrorRemarks("");
      setErrorStoreLocation("");
      setErrorContactPerson("");
      setErrorMobileNumber("");
      setErrorStatus("");
    } else {
      setIsSubmitted(false);
      handlePostData();
      setIsUpdated(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    //setIsLoading(true);
    const apiUrl = getMainStoreMaster;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    setTimeout(() => {
      axios
        .get(apiUrl, { headers })
        .then((response) => {
          console.log("response", response);
          setData(response.data.response.MainStore);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        });
    }, 900);
  };

  const handlePostData = async () => {
    const apiUrl = addMainStoreMaster;
    const headers = await GetApiHeaders();
    const postData = {
      Id: Id == 0 ? "" : Id.toString(),
      name: name,
      storeLocation: storeLocation,
      userID: headers.userId,
      contactPerson: contactPerson,
      contactMobileNumber: contactMobileNumber,
      status: status, // 0 means Inactive, 1 means Active
    };

    console.log("request with api call", apiUrl);

    console.log("request with api call", postData);
    setIsLoading(true);
    // Make the POST request using Axios
    axios
      .post(apiUrl, postData, { headers })
      .then((response) => {
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);

        // Handle the successful response here
        console.log("submit Response:", response);
      })
      .catch((error) => {
        setIsLoading(false);
        // Handle errors here
        console.error("Error:", error);
      });
  };

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  //for data table

  const tableRef = useRef(null);

  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }
    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
  }, []);

  ///modal popup

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setErrorName("");
    setErrorRemarks("");
    setShowModal(true);
    setId(0);
    setName("");
    setStoreLocation("");
    // setUserId("");
    setContactPerson("");
    setContactMobileNumber("");
    setStatus("");
    setModalData({
      Id: "",
      name: "",
      storeLocation: "",
      // userId: '',
      contactPerson: "",
      contactMobileNumber: "",
      remarks: "",
      status: "",
    });
  };

  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    setRefreshKey((prevKey) => prevKey + 1);
    window.location.reload();
  };
  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowWarningPopup(false);
    setShowMsg(true);
  };

  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleModalClose = () => {
    setShowModal(false);
    setRefreshKey((prevKey) => prevKey + 1);
  };
  const updatedItems = (item) => {
    // setModalData(item)
    setId(item.id);
    setName(item.name);
    setStoreLocation(item.storeLocation);
    // setUserId(item.userId);
    setContactPerson(item.contactPerson);
    setContactMobileNumber(item.contactMobileNumber);
    setStatus(item.status);
    setRemarks(item.remarks);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In Active" },
  ];

  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}
        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">Masters</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text">
                          Main Store Master
                        </h6>
                      </div>
                      <span
                        className="d-inline-block"
                        tabIndex="0"
                        data-toggle="tooltip"
                        title="Add Store Master"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>

                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />
                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />
                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div
                          className="card-body"
                          style={{ overflowX: "auto" }}
                        >
                          <Table className="table table-bordered Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("name")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Name
                                    {renderSortIcon("name")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("storeLocation")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Store Location
                                    {renderSortIcon("storeLocation")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("contactPerson")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Contact Person
                                    {renderSortIcon("contactPerson")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("contactMobileNumber")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Contact Mobile Number
                                    {renderSortIcon("contactMobileNumber")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("status")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Status
                                    {renderSortIcon("status")}
                                  </span>
                                </Th>

                                <Th className="text-center cursor-pointer"
                                  onClick={() => handleSort("actions")}>
                                  Actions
                                </Th>
                              </Tr>
                            </Thead>

                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={19}
                                    className="text-center"
                                    style={{ padding: 195, fontSize: 18 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems != undefined &&
                                currentItems != null &&
                                currentItems.map((item, i) => (
                                  // console.log("item", i);
                                  // return (
                                  <Tr key={i + 1}>
                                    <Td className="text-left">{(currentPage - 1) * itemsPerPage + i + 1}</Td>
                                    <Td>{item.name}</Td>
                                    <Td>{item.storeLocation}</Td>
                                    <Td>{item.contactPerson}</Td>
                                    <Td className="text-right">
                                      {item.contactMobileNumber}
                                    </Td>
                                    <Td className="text-center">
                                      {item.status === "1" ? (
                                        <span style={{ color: "#4A7729" }}>
                                          Active
                                        </span>
                                      ) : (
                                        <span style={{ color: "#FF0000" }}>
                                          In Active
                                        </span>
                                      )}
                                    </Td>
                                    <Td className="text-center">
                                      <div>
                                        <img
                                          src={Edit_Icon}
                                          alt="Edit Store"
                                          title="Edit Store"
                                          className="editicon"
                                          onClick={() => updatedItems(item, i)}
                                        />
                                      </div>
                                    </Td>
                                  </Tr>
                                  // );}
                                ))
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                        </div>
                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />

                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>

                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">
                                  Main Store Master
                                </span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputName"
                                    className="form-label text-md font-weight-600 mb-0"
                                  >
                                    Main Store Master Name
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Main Store Master Name"
                                      value={name}
                                      onChange={handleNameChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorName}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputText"
                                    className="form-label text-md font-weight-600 mb-0"
                                  >
                                    Store Location
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Store Location"
                                      value={storeLocation}
                                      onChange={handleStoreLocationChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStoreLocation}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="InputUserName"
                                    className="form-label text-md font-weight-600 mb-0"
                                  >
                                    Contact Person
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Contact Person"
                                      value={contactPerson}
                                      inputMode="text"
                                      onChange={handleContactPersonChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorContactPerson}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="Inputnumber"
                                    className="form-label text-md font-weight-600 mb-0"
                                  >
                                    Contact Mobile Number
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Mobile Number"
                                      value={contactMobileNumber}
                                      onChange={handleMobileNbr}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorMobileNumber}
                                  </span>
                                </div>
                                <div className="col-md-6 mt-2">
                                  <label
                                    for="Input"
                                    class="form-label text-md font-weight-600 mb-0"
                                  >
                                    Status
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (option) => option.value === status
                                      )}
                                      onChange={(selectedOption) =>
                                        handleStatus({
                                          target: { value: selectedOption?.value || "" },
                                        })
                                      }
                                      placeholder="Select Status"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />

                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStatus}
                                  </span>
                                </div>
                              </div>
                              &nbsp;
                              <div className="row">
                                {isSubmitted ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.recordSubmitted}.
                                  </p>
                                ) : null}

                                {isUpdated ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.updatedSuccessfully}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center col-md-12">
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() => handleSubmit()}
                                >

                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>

                                <Button
                                  onClick={handleCancel_new}
                                  className="btnn btn btn-danger"
                                >
                                  Cancel
                                </Button>
                              </div>
                              {recordExists && <p>{recordExists}</p>}
                            </Modal.Body>
                          </Modal>
                        </div>

                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  {" "}
                                  Main Store Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close Window ?
                                  </p>
                                ) : null}
                              </div>

                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>

                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  {" "}
                                  Main Store Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  MainStore Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}
          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->
                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default MainStoreMaster;
